import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <>
      <head>
        <link rel="stylesheet" href="index.css" />
        <title>Kush Goel</title>
        <link rel="icon" type="image/x-icon" href="wordmark-favicon.ico" />
      </head>
      <body>
        <div id="AboutMe">
          <div id="AboutMeHeader">A little history...</div>
          <div id="timelineContainerContainer">
            <div id="timelineBar"></div>
            <div id="timelineContainer">
              <div id="timeline">
                <div class="olympiad">
                  <div class="timelineEventBottom">
                    <div class="timelineEventDateBottom">June 2022</div>
                    <div class="timelineEventCircleBottom"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptBottom">
                      <div class="timelineEventDescriptTitle">
                        Started Learning Physics
                      </div>
                      <div class="timelineEventDescriptText">
                        I already had a passion for STEM - especially math. And
                        it wasn't until I started reading my first physics
                        textbook that physics completely took me over. Day in
                        and dayout I awas doing problems, better grasping the
                        physical world.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="robotics">
                  <div class="timelineEventTop">
                    <div class="timelineEventDateTop">Oct 2022</div>
                    <div class="timelineEventCircleTop"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptTop">
                      <div class="timelineEventDescriptTitle">
                        Joined Team 846
                      </div>
                      <div class="timelineEventDescriptText">
                        As a young, aspring freshman in high school, I got my
                        first taste of FRC Robotics at the Software Workshops of
                        Team 846, The Funky Monkeys, my local highschool's
                        robotics team, sparking a journey that would last for
                        ages.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="research">
                  <div class="timelineEventBottom">
                    <div class="timelineEventDateBottom">June 2023</div>
                    <div class="timelineEventCircleBottom"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptBottom">
                      <div class="timelineEventDescriptTitle">
                        Joined ASDRP Laurenzio Lab
                      </div>
                      <div class="timelineEventDescriptText">
                        For a long time, I had been interested in research. That
                        summer was the first time the idea become a reality,
                        with me researching the Self-Organizing Maps (SOM)
                        Neural Networks and their ability to analyze various
                        mathemetical figures and shapes.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="drama">
                  <div class="timelineEventTop">
                    <div class="timelineEventDateTop">April 2023</div>
                    <div class="timelineEventCircleTop"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptTop">
                      <div class="timelineEventDescriptTitle">
                        Clue: A Production
                      </div>
                      <div class="timelineEventDescriptText">
                        As an actor of Lynbrook High School's Drama Program, the
                        program put together a theatre adaptation of the famous
                        farce Clue, playing the police officeras well as the
                        murderer.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="research">
                  <div class="timelineEventBottom">
                    <div class="timelineEventDateBottom">July 2023</div>
                    <div class="timelineEventCircleBottom"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptBottom">
                      <div class="timelineEventDescriptTitle">
                        SIP Research Intern
                      </div>
                      <div class="timelineEventDescriptText">
                        As a part of UCSC's Science Internship Program (SIP), I
                        assisted my mentor, Archana Singh, in analyzing and
                        simulating a new techinque of Quantum Key Distribution
                        (QKD), and various different quantum crypotgraphy
                        algorithms.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="olympiad">
                  <div class="timelineEventTop">
                    <div class="timelineEventDateTop">November 2023</div>
                    <div class="timelineEventCircleTop"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptTop">
                      <div class="timelineEventDescriptTitle">AMC 10B DHR</div>
                      <div class="timelineEventDescriptText">
                        After qualifying for the AIME the previous year, I
                        scored a 139.5 on the AMC 10B of 2023, earning me a
                        distinguished honor roll. I would later qualify for the
                        AIME and be 1.5 points off of participating in the
                        USAJMO.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="research">
                  <div class="timelineEventBottom">
                    <div class="timelineEventDateBottom">June 2024</div>
                    <div class="timelineEventCircleBottom"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptBottom">
                      <div class="timelineEventDescriptTitle">
                        Joined ASDRP Subramanium Lab
                      </div>
                      <div class="timelineEventDescriptText">
                        This summer, I switched over to the Subramanium Lab at
                        ASDRP, eventually becoming the Software Lead, now
                        developing a drone to analyze the outdoor surroundings
                        of a natural disaster and generate routes for first
                        responders.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="drama">
                  <div class="timelineEventTop">
                    <div class="timelineEventDateTop">November 2024</div>
                    <div class="timelineEventCircleTop"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptTop">
                      <div class="timelineEventDescriptTitle">
                        Laughing Stock
                      </div>
                      <div class="timelineEventDescriptText">
                        Making a return to Lynbrook High School's Drama Program
                        as a lead character in the new production "Laughing
                        Stock", we performed for four nights in a well0reherased
                        farce/comedy.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="research">
                  <div class="timelineEventBottom">
                    <div class="timelineEventDateBottom">March 2025</div>
                    <div class="timelineEventCircleBottom"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptBottom">
                      <div class="timelineEventDescriptTitle">
                        Synopsys Science Fair
                      </div>
                      <div class="timelineEventDescriptText">
                        Won the 1st place award sponosered by Access Braille for
                        my work in helping the visually impaired navigate new
                        and unfamiliar areas through the use of a novel new
                        Active SLAM alogirhtm, accounting for dynamic objects.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="olympiad">
                  <div class="timelineEventTop">
                    <div class="timelineEventDateTop">March 2025</div>
                    <div class="timelineEventCircleTop"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptTop">
                      <div class="timelineEventDescriptTitle">
                        USAPhO 3x Qualifier
                      </div>
                      <div class="timelineEventDescriptText">
                        Qualified for the USA Physics Olympiad (USAPhO),
                        comprising of the top ~450 high school physicists in the
                        nation for the third time, after getting an honorable
                        mention in 2023 and a bronze medal in 2024.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="robotics">
                  <div class="timelineEventBottom">
                    <div class="timelineEventDateBottom">April 2025</div>
                    <div class="timelineEventCircleBottom"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptBottom">
                      <div class="timelineEventDescriptTitle">
                        Aerospace Valley Regional Finalists
                      </div>
                      <div class="timelineEventDescriptText">
                        In the 2025 FRC season, Team 846 built the robot Monkey
                        D. Luffy, which ended up being finalists in a
                        painstakingly close finals at Aerospace Valley Regional,
                        putting an end to our season, although we got to take
                        home the Excellence in Engineering award.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="robotics">
                  <div class="timelineEventTop">
                    <div class="timelineEventDateTop">May 2025</div>
                    <div class="timelineEventCircleTop"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptTop">
                      <div class="timelineEventDescriptTitle">
                        Northern California Invitational Winners
                      </div>
                      <div class="timelineEventDescriptText">
                        In the 2025 FRC off-season, Monkey D. Luffy returned
                        better than ever to the Northern California
                        Invitational, with improved software and a now working
                        deep climb! After being the 1st pick for alliance 1,
                        Team 846 fought their way through the playoffs to win
                        the whole thing, also winning the Innovation in Control
                        Award!
                      </div>
                    </div>
                  </div>
                </div>
                <div class="job">
                  <div class="timelineEventBottom">
                    <div class="timelineEventDateBottom">June 2025</div>
                    <div class="timelineEventCircleBottom"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptBottom">
                      <div class="timelineEventDescriptTitle">
                        Joined ScriptSense
                      </div>
                      <div class="timelineEventDescriptText">
                        As a remote intern, I joined ScriptSense, a company
                        digitalizing the pharamaceutical process which was based
                        in New Zealand. As an AI/ML Intern, I developed the LLM
                        system to enhance doctor prescription instructions, as
                        well as found ways to test the system prompts.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="research">
                  <div class="timelineEventTop">
                    <div class="timelineEventDateTop">July 2025</div>
                    <div class="timelineEventCircleTop"></div>
                    <div class="timelineEventConnector"></div>
                    <div class="timelineEventDescriptTop">
                      <div class="timelineEventDescriptTitle">
                        SIP Research Intern
                      </div>
                      <div class="timelineEventDescriptText">
                        As a part of UCSC's Science Internship Program (SIP), I
                        assisted my mentor, Esteban Ramos, in analyzing and
                        comparing mutex performance between far-memory CXL
                        environments and local environments. Our findings are
                        in-review for the EuroSys 2026 conference.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="Home">
          <img src="radiant-gradient.svg" id="background" />
          <img src="coolbackgrounds-topography-rose.svg" id="backgroundLay" />
          <div id="imgSide">
            <div id="profile">
              <img id="profileImg" src="profile.jpg" alt="A photo of Kush!" />
            </div>
          </div>
          <div id="textSide">
            <div id="nameIntro">
              <h1>'Sup, I'm</h1>
            </div>
            <div id="name">
              <h1>Kush Goel</h1>
            </div>
            <div id="nameLabel">
              <h2 id="nameLabelText">Roboticist, Physicist, Actor, Thinker</h2>
            </div>
            <div id="darkMediaRow">
              <img
                src="icons/darkyoutube.png"
                alt="youtube"
                class="darkMediaIcon"
              />
              <img src="icons/darkmail.png" alt="mail" class="darkMediaIcon" />
              <img
                src="icons/darkgithub.png"
                alt="github"
                class="darkMediaIcon"
              />
              <img
                src="icons/darklinkedin.png"
                alt="linkedin"
                class="darkMediaIcon"
              />
            </div>
            <div id="colorMediaRow">
              <a href="https://www.youtube.com/channel/UC39gnKB-gFVLOo2cbWImO4g">
                <img
                  src="icons/coloryoutube.png"
                  alt="youtube"
                  class="colorMediaIcon"
                />
              </a>
              <a href="mailto:kushgoel08@gmail.com">
                <img
                  src="icons/colormail.png"
                  alt="mail"
                  class="colorMediaIcon"
                />
              </a>
              <a href="https://github.com/kGoel647">
                <img
                  src="icons/colorgithub.png"
                  alt="github"
                  class="colorMediaIcon"
                />
              </a>
              <a href="https://www.linkedin.com/in/kush-goel-780664286">
                <img
                  src="icons/colorlinkedin.png"
                  alt="linkedin"
                  class="colorMediaIcon"
                />
              </a>
            </div>
          </div>
        </div>
        <div id="MyProjects">
          <div id="ProjectHeader">My Projects</div>
          <div id="ProjectGrid">
            <div class="projectRow">
              <a href="https://lynbrookrobotics.com" target="_blank">
                <div class="project">
                  <img class="projectImage" src="logo846.png" />
                  <div class="projectDescription">
                    <span class="projectSpan">
                      I am currently the Co-President of Lynbrook Robotics Team,
                      also known as Team 846, or The Funky Monkeys. Before being
                      president, I was the co-software lead, developing the
                      codebase for autnonomous routines and vision processing
                    </span>
                  </div>
                </div>
              </a>
              <a
                style={{ textDecoration: "none" }}
                href="files/NAV-D-SLAM.pdf"
                target="_blank"
              >
                <div class="project">
                  <div class="projectImage" src="profile.jpg">
                    NAV-D-SLAM
                  </div>
                  <div class="projectDescription">
                    <span class="projectSpan">
                      A novel SLAM (Simulataneous Localization and Mapping)
                      algorithm accounting for dynamic objects that autonomously
                      navigates new and unfamiliar areas.
                    </span>
                  </div>
                </div>
              </a>
            </div>
            <div class="projectRow">
              <a                 style={{ textDecoration: "none" }}
                href="files/CXL_Mutex_Sync.pdf"
                target="_blank">
                <div class="project">
                  <div class="projectImage" src="profile.jpg">
                    Mutex Benchmark
                  </div>
                  <div class="projectDescription">
                    <span class="projectSpan">
                      As an SIP intern at UCSC, I developed a collection of 60+
                      mutexes from various papers to compare their efficacy in
                      far-memory environments versus local environments,
                      eventually culminating into a paper submitted at
                      EuroSys2026.
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <nav id="navBar">
          <a href="https://www.kushgoel.dev">
            <img src="wordmark-favicon.png" id="logo" />
          </a>
          <div id="navLabels">
            <a class="navLabel" href="#Home">
              Home
            </a>
            <a class="navLabel" href="#AboutMe">
              About me
            </a>
            <a class="navLabel" href="#MyProjects">
              Projects
            </a>
            <a
              class="navLabel"
              href="files/Kush Goel's Resume.pdf"
              target="_blank"
            >
              Resume
            </a>
          </div>
        </nav>
      </body>
    </>
  );
}

export default App;
